export default {
    availableLanguages: ['fr', 'en'],

    user: null,
    activeStore: null,
    busy: false,
    language: null,
    baseUrl: null,
    lastRoute: null,
    isRouterBusy: false,
    notificationCount: null,
    currentPageState: {
        name: null,
        type: null,
        current: null
    },
    menuItems: [],
    currentRoute: null,
};



// WEBPACK FOOTER //
// ./src/store/bmr/state.js